import Filter from "../../components/Filter";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import TeamCards from "../TeamCards";
import MySkill from "./MySkill";
import React, { useState,useEffect } from "react";


function MySkillMain (){
  const [ isManagerorHR, setIsManagerorHR] = useState(false);
  useEffect(() => {
    let role = localStorage.getItem('userrole');
    setIsManagerorHR(role === 'ROLE_MANAGER' || role === 'ROLE_SUPERVISOR' || role === 'ROLE_HR');
  }, []);
  


    return(
        <>
        
        <Dummylayout/>
      <BasicCard>
      <div className='row border-1'>
      <div className='col-lg-6'>
        <h4 className="text-start pb-3"> My Skills</h4>
      </div>
      <div className='col-lg-6 text-end bg-white '>
        { isManagerorHR ? ( 
      <a href='SkillsForms?mgr=1' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Add Skills</button></a>
        ):(
          <a href='SkillsForms' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Add Skills</button></a>
          )} 
      </div>
     
      </div>
        <MySkill/>
      </BasicCard>
   
     
        </>

    );

   
}
export default MySkillMain;